var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 7.24152L15.83 5.78647C16.2213 5.39524 16.8581 5.39778 17.2514 5.79107L18.7098 7.24946C19.1036 7.64323 19.1036 8.28167 18.7144 8.67084L17.2594 10.1259L14.375 7.24152ZM5.50242 19.5004C5.22493 19.5004 4.99999 19.274 5 18.998L5.00007 17.1183C5.00008 16.8409 5.16523 16.4508 5.35005 16.266L13.6538 7.96215L16.5382 10.8465L8.23441 19.1503C8.04114 19.3436 7.65812 19.5003 7.38202 19.5003L5.50242 19.5004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.890822bbfc77e8cfa307bfa68174e5fe.svg";
export { ForwardRef as ReactComponent };